module.exports = __webpack_public_path__ + "40c8da08c7c43980dca4226f858f1150.svg";